import styled from 'styled-components';
import EnterCodeForm from './EnterCodeForm';
import CreateNewScreenForm from './CreateNewScreenForm';
import { Colors } from 'basic-ui-lib';

interface EnterCodeProps {
  storeId: string;
  onContinue: () => void;
}

const EnterCode = ({ storeId, onContinue }: EnterCodeProps) => {
  return (
    <Container>
      <EnterCodeForm storeId={storeId} onContinue={onContinue} />
      <CreateNewScreenForm storeId={storeId} onContinue={onContinue} />
    </Container>
  );
};

export default EnterCode;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;

  .enter-code,
  .create-new {
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: space-between;
    padding: 24px 32px;
    background-color: ${Colors.neutral.bg[2]};
    border-radius: 16px;
    height: 100%;
  }

  .box-icon {
    width: 64px;
    height: 64px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-form-item {
    margin-bottom: 0;
  }
`;
